/* eslint-disable @tseslint/typedef */

export const CACHED_EMAIL_REMEMBER = "cached-email-remember";
export const CACHED_EMAIL_RESET = "cached-email-reset";
